var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{ref:"modal",attrs:{"width":"50%","title":_vm.title},on:{"closed":function($event){return _vm.$emit('closed')}}},[_c('FileFormat',{attrs:{"id":_vm.id,"format":_vm.format,"type":_vm.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }